<template>
  <div id="product">
  <div class="banner container-fuild text-center" :class="bannerClass">{{ name[lang] }}</div>
    <div class="container">
      <div class="product-container wow pulse">
        <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
          <el-tab-pane
            v-for="(item, index) in items"
            style="font-size: 100px"
            :key="index"
            :label="item.name[lang] || item.name"
            :name="index + ''"
          >
            <div class="container col-xs-12 col-sm-12 col-md-12">
              <div class="product-container row">
                <div
                  class="product-item col-xs-12 col-sm-6 col-md-3 wow slideInUp"
                  v-for="(item, index) in product"
                  :key="index"
                  @click="goToPage(item)"
                >
                  <div class="product-item-wrapper">
                    <div class="product-item-top">
                      <h4>{{ item.name[lang] || item.name }}</h4>
                      <i class="isty"></i>
                      <p data-i18n="homePage_more">查看更多</p>
                    </div>
                    <p class="title">
                      {{ item.introduce[lang] || item.introduce }}
                    </p>
                    <div class="product-item-img">
                      <img :src="item.image" alt="产品图" />
                    </div>
                    <div class="product-item-border"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { websiteUrl, fileUrl } from "../../url.js";
import { translatePage } from '../assets/js/languages/change_language';
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { WOW } from "wowjs";

export default {
  name: "product",
  props: ["index", "id"],
  data() {
    return {
      index: "1",
      activeName: "0",
      items: [],
      product: [],
      name: {}
    };
  },
  watch: {
    // 监听路由参数变化
    $route: {
      immediate: true, // 初始化时也执行
      handler(to, from) {
        console.log(to, from);
        // 更健壮的比较方式
        const idChanged = String(to.path) !== String(from.path);

        if (idChanged) {
          this.getProductlist();
          this.getInfo();
          setTimeout(() => {
            translatePage();
          }, 50)
          // 更合理的index设置逻辑
          this.index = this.$route.query.tabIndex || "0"; // 默认0更符合数组索引
        }
      },
    },
  },
  async mounted() {
    var wow = new WOW();
    wow.init();
    await this.getProductlist();
    await this.getInfo();
    setTimeout(() => {
      translatePage();
    }, 50)
  },
  // 语言变量 计算属性
  computed: {
    lang() {
      return sharedState.lang;
    },
    bannerClass() {
      const path = this.$route.path.replace(/\/+$/, "");
      if (path === "/product/center") return 'banner-product';
      if (path === "/product/success") return 'banner-case';
      return 'banner-product';
    }
  },
  methods: {
    // 根据当前路由决定是"产品中心"还是"成功案例"；nginx 会给预渲染目录补末尾斜杠，需去掉再比较
    getProductId() {
      const path = this.$route.path.replace(/\/+$/, "");
      if (path === "/product/center") return "1932996173371469826";
      if (path === "/product/success") return "1937700611953401857";
      return null;
    },
    async getInfo() {
      const id = this.getProductId();
      const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/product/getInfo/${id}`
        );
        console.log(response.data);
        this.name = JSON.parse(response.data.data.name);
        console.log(this.name);
    },
    //根据id获取tabs数据
    async getProductlist() {
      //缓存
      const cache = localStorage.getItem("productlistData");
      if (cache) {
          this.items = JSON.parse(cache);
      }
      try {
        const id = this.getProductId();
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/productClass/list?belongProduct=${id}`
        );
        const data = response.data.rows;
        console.log(data[0].name);
        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
          }
        }
        this.items = data;
        if (this.items.length > 0) {
          // 首页跳转时通过 ?tabIndex=N 指定初始 tab，越界则回退到第一个
          const q = Number(this.$route.query.tabIndex);
          const i = Number.isInteger(q) && q >= 0 && q < this.items.length ? q : 0;
          this.activeName = i + "";
          this.activeTabId = this.items[i].id;
          this.getProduct(this.items[i].id);
          this.revealWow();
        }
        localStorage.setItem("productlistData", JSON.stringify(this.items));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    // 根据tabs的id获取页面内容
    async getProduct(id) {
      console.log(id);
      const cache = localStorage.getItem("products");
      if (cache) {
          this.product = JSON.parse(cache);

        // for (let index = 0; index < this.product.length; index++) {
        //   const item = this.product[index];
        //   item.content = JSON.parse(item.content)
        // }

        console.log(this.product);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/productDetails/list?belongClass=${id}`
        );
        const data = response.data.rows;
        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
            data[index].introduce = JSON.parse(data[index].introduce);
            data[index].content = JSON.parse(
              data[index].content.replaceAll("${baseUrl}", fileUrl)
            );
            data[index].image = fileUrl + data[index].image;
          }
        }
        this.product = response.data.rows;
        console.log(this.product), "huoqu";
        localStorage.setItem("products", JSON.stringify(this.product));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleClick(tab) {
      const selectedIndex = Number(tab.name);
      console.log(selectedIndex);
      if (this.items[selectedIndex]) {
        this.activeTabId = this.items[selectedIndex].id;
        this.getProduct(this.items[selectedIndex].id);
      }
      this.revealWow();
    },
    // WOW.js 会把初始化时处于隐藏 tab 里的元素设为 visibility:hidden，需触发一次 scroll 让它重新检测并显示
    revealWow() {
      this.$nextTick(() => window.dispatchEvent(new Event("scroll")));
    },
    goToPage(item) {
      console.log(item, "item111111111");
      // 跳转到对应的产品详情页面
      this.$router.push({
        name: "software",
        params: {
          belongClass: item.belongClass,
          id: item.id,
        },
      });
    },
  },
};
</script>
<style>
/* element组件样式调整 */
.el-tabs__item:hover {
  color: #003987;
  cursor: pointer;
}

.el-tabs__item {
  font-size: 20px;
}

.el-tabs__item.is-active {
  color: #003987;
  font-size: 24px;
}

.el-tabs__active-bar {
  background-color: #003987;
}
</style>
<style scoped>
.banner-product {
  color: #fff;
  font-size: 30px;
  height: 400px;
  line-height: 400px;
  background-image: url("../assets/img/banner_cp.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
.banner-case {
  color: #fff;
  font-size: 30px;
  height: 400px;
  line-height: 400px;
  background-image: url("../assets/img/banner_al.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
#product {
  margin-top: 62px;
}

/* .product-container {
  /* margin: 10px 10px;
  padding: 30px;
  transition: all ease 0.5s; */
/* border: 1px dashed salmon;
} */
/* .product-container h2 {
  color: rgb(255, 102, 19);
  font-weight: bolder;
  text-align: center;
}
.product-container p {
  font-size: 20px;
  color: rgb(255, 102, 19);
  font-weight: 700;
}
.product-container ol {
  list-style-type: decimal;
  padding-left: 30px;
}
.product-container ol > li {
  font-size: 14px;
  line-height: 2.7rem;
} */
.product-container {
  padding: 30px 10px;
}

.product-item {
  margin-bottom: 30px;
}

.product-item-wrapper {
  display: flex;
  flex-direction: column;
  height: 340px;                /* 固定高度，确保所有卡片一致 */
  background: rgba(244, 244, 244, 1);
  border-radius: 12px;          /* 圆角，可自行调整数值 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 阴影，增强立体感 */
  transition: all 0.3s ease;
  overflow: hidden;             /* 确保圆角裁剪内容，同时保留内部溢出隐藏 */
  cursor: pointer;
  position: relative;
}

.product-item-top {
  width: 100%;
  height: 100px;
  padding: 30px;
  text-align: center;
  /* justify-content: center; */
  /* align-items: center; */
}

.product-item-top > i {
  display: block;
  margin-left: 43%;
  width: 25px;
  height: 2px;
  background: #003987;
  z-index: 999;
}

.product-item-top > p {
  margin-top: 5px;
  color: #003987;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.3s ease;
  font-size: 16px;
  /* display: inline-block; */
  position: relative;
  padding-bottom: 3px;
}
.product-item-top > p::after {
  content: "";
  position: absolute;
  width: 0;
  height: 1px;
  bottom: 0;
  left: 50%;
  background: #003987;
  transition: all 0.3s ease;
}

.title {
  padding: 0 15px;
  color: #b2b2b2;
  font-size: 14px;
  text-indent: 4ch;
  display: -webkit-box;
  -webkit-line-clamp: 4;  /* 最多显示3行，可根据需要调整 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;          /* 防止被压缩 */
  margin-bottom: 12px;     /* 与图片间距 */
}

.product-item-img {
  width: 100%;
  height: 180px;          /* 固定高度 */
  overflow: hidden;
}

.product-item-img img {
  width: 100%;
  height: 100%;
  object-fit: fill;       /* 拉伸填满，可能变形 */
}

.product-item-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 99;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  /* border: 1px solid #000; */
  opacity: 0;
}

.product-item-wrapper:hover .product-item-top > i {
  opacity: 0;
}

.product-item-wrapper:hover .product-item-top > p {
  opacity: 1;
  transform: translateY(-10px);
}
.product-item-wrapper:hover .product-item-top > p::after {
  width: 100%;
  left: 0;
}

.product-item-wrapper:hover .product-item-img > img {
  transform: scale(1.05, 1.05);  /* 稍微缩小缩放比例 */
}

.product-item-wrapper:hover > .product-item-border {
  opacity: 1;
  width: 90%;
  height: 90%;
}
@media screen and (max-width: 768px) {
  .product-item-wrapper {
    height: auto;
  }
  .product-item-img {
    height: auto;
  }
  .title {
    -webkit-line-clamp: unset;
  }
}
@media screen and (max-width: 997px) {
  .product-container {
    margin: 20px 0;
    padding: 20px;
    border: 1px dashed salmon;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product.vue